module.exports = __webpack_public_path__ + "img/1moblie.c0f638ba.png";